<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    @if (!isSearchFocused) {
      @if (canCreate) {
        <app-primary-button (click)="create()" class="!w-[150px]"> Create </app-primary-button>
      }
      @if (rfiReport) {
        <div class="download-button-container">
          @if (downloading) {
            <mat-spinner
              color="primary"
              diameter="24"
              mode="indeterminate"
              strokeWidth="3"
              >
            </mat-spinner>
          }
          @if (!downloading) {
            <button
              (click)="downloadRfiReport()"
              class="download-button"
              mat-icon-button
              [matTooltip]="statusIdsToFilter?.length ? 'Download filtered RFIs' : 'Download all RFIs'"
              >
              <mat-icon>download</mat-icon>
            </button>
          }
        </div>
      }
      <div class="rfi-filters flex flex-row gap-[20px] flex-1 mt-[7px]">
        <app-project-details-page-date-filter [defaultDateValue]="defaultDateValue" />
        <app-status-filter [statusOptions]="statusList" />
        <div>
          @if (selectedSortColumn) {
            <mat-form-field class="sort-dropdown">
              <mat-select
                (selectionChange)="onSortColumnChange($event)"
                [(value)]="selectedSortColumn"
                disableOptionCentering
                panelClass="rfi-sort-panel"
                >
                <mat-select-trigger>
                  {{ selectedSortColumn ? 'Sort by: ' + selectedSortColumn : 'Sort: ' }}
                </mat-select-trigger>
                @for (column of sortByColumns; track column) {
                  <mat-option [value]="column">
                    {{ column | titlecase }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon (click)="removeSort($event)" class="sort-close" matSuffix> close</mat-icon>
            </mat-form-field>
          }
          @if (!selectedSortColumn) {
            <div (click)="openSortDropdown($event)" class="sort-dropdown nosort">
              <div class="label text-type-8">Sort:</div>
              <mat-icon>sync_alt</mat-icon>
              <mat-form-field class="sr-sort-hidden">
                <mat-select
                  #sortSelect
                  (selectionChange)="onSortColumnChange($event)"
                  [(value)]="selectedSortColumn"
                  disableOptionCentering
                  panelClass="rfi-sort-panel"
                  >
                  @for (column of sortByColumns; track column) {
                    <mat-option [value]="column">
                      {{ column | titlecase }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
        <div class="search-section flex flex-1 flex-row gap-[10px] min-w-0">
          <form [formGroup]="form" class="flex-1 min-w-0">
            <div class="search w-full">
              <mat-icon (click)="search()" svgIcon="search"></mat-icon>
              <input
                (focus)="onSearchFocus()"
                class="search-input"
                formControlName="searchText"
                matInput
                placeholder="Search"
                />
              @if (form?.controls?.searchText?.value) {
                <mat-icon (click)="close()" svgIcon="close"></mat-icon>
              }
            </div>
          </form>
        </div>
      </div>
    } @else {
      <form [formGroup]="form" class="flex-1 min-w-0">
        <div class="search w-full">
          <mat-icon (click)="search()" svgIcon="search"></mat-icon>
          <input
            #searchInput
            (focus)="onSearchFocus()"
            class="search-input"
            formControlName="searchText"
            matInput
            placeholder="Search"
            />
          <mat-icon (click)="close()" svgIcon="close"></mat-icon>
        </div>
      </form>
    }

  </div>

  <div class="list-section">
    <div class="rfi-list-table flex flex-col gap-[40px]">
      @if (dataSource?.length) {
        <div class="bit-items-table">
          <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
            <ng-container matColumnDef="rfiNo">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'RFI no'" mat-header-cell>
                <span class="th-text">RFI #</span>
                @if (selectedSortColumn === 'RFI no') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-8">{{ row?.rfi_no }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="title">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Title'" mat-header-cell>
                <span class="th-text">Title</span>
                @if (selectedSortColumn === 'Title') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-8">{{ row?.title }}</div>
                <div class="description text-type-14">{{ row?.description }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="needByDate">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Need by date'" mat-header-cell>
                <span class="th-text">Need By Date</span>
                @if (selectedSortColumn === 'Need by date') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.need_by_date | date : 'MMM d, y' }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th
                *matHeaderCellDef
                [class.ellipsis-header]="selectedSortColumn === 'Status'"
                class="text-type-6 !leading-[24px]"
                mat-header-cell
                >
                <span class="th-text">Status</span>
                @if (selectedSortColumn === 'Status') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="status-chip-container">
                  <div
                  [ngClass]="
                    row?.status && statusMap[row?.status]
                      ? [statusMap[row.status].bgColor, statusMap[row.status].textColor]
                      : []
                  "
                    class="status-chip px-[14px] rounded-full"
                    >
                    @if (role === 'project-manager' || role === 'org-admin') {
                      @if (row?.status === 'submitted') {
                        Open
                      } @else {
                        {{ statusMap[row?.status]?.label }}
                      }
                    }
                    @if (role === 'contractor' || role?.includes('contractor') || role === 'reviewer') {
                      @if (row?.status === 'submitted' || row?.status === 'sent_for_review') {
                        Open
                      } @else {
                        {{ statusMap[row?.status]?.label }}
                      }
                    }
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="createdAt">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Created at'" mat-header-cell>
                <span class="th-text">Created at</span>
                @if (selectedSortColumn === 'Created at') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ formatInProjectTimezone(row?.created_at, 'MMM D, YYYY') }}</div>
                <div class="text-type-14">{{ formatInProjectTimezone(row?.created_at, 'h:mm A') }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="latestActivity">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Latest activity'" mat-header-cell>
                <span class="th-text">Latest activity</span>
                @if (selectedSortColumn === 'Latest activity') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="action text-type-11">{{ row?.latest_lineage?.state?.comment }}</div>
                <div class="actor text-type-14">
                  {{ row?.latest_lineage?.actor?.first_name }} {{ row?.latest_lineage?.actor?.last_name }}
                </div>
                <div class="created-at text-type-14">
                  {{ formatInProjectTimezone(row?.latest_lineage?.created_at, 'MMM D, YYYY, h:mm A') }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th *matHeaderCellDef mat-header-cell><span class="cdk-visually-hidden">Actions</span></th>
              <td *matCellDef="let row" mat-cell>
                <button mat-icon-button [matMenuTriggerFor]="rfiRowMenu"
                  [attr.aria-label]="'Actions for RFI ' + row.rfi_no"
                  [disabled]="!!deletingRfiId || !!downloadingRfiId"
                  (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #rfiRowMenu="matMenu">
                  @if (canDeleteRfi(row)) {
                    <button mat-menu-item [disabled]="!!deletingRfiId"
                      (click)="deleteRfi(row, $event)">
                      <mat-icon svgIcon="trash"></mat-icon>
                      <span>Delete</span>
                    </button>
                  }
                  <button mat-menu-item (click)="downloadRfiDetail(row, false, $event)">
                    <mat-icon>download</mat-icon>
                    <span>Download PDF</span>
                  </button>
                  <button mat-menu-item (click)="downloadRfiDetail(row, true, $event)">
                    <mat-icon>forum</mat-icon>
                    <span>Download PDF with discussions</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr
              data-testid="rfi-row"
              (click)="rowClicked(row)"
              *matRowDef="let row; columns: displayedColumns"
              [class.highlighted-row]="row === selectedRow"
              mat-row
            ></tr>
          </table>
        </div>
      }

      @if (!dataSource?.length) {
        <div class="no-data text-type-8 mt-[80px]">No data available.</div>
      }

      <app-paginator
        (pageChanged)="onPageChanged($event)"
        [itemsPerPage]="pagination?.pageSize"
        [maxVisiblePages]="5"
        [totalItems]="totalRecords"
        class="paginator"
        />
    </div>
  </div>
</div>
